import * as React from 'react';
import { FormControl } from '@common/components/form-control';
import { trDts } from '@modules/datasheets/utils/i18n';
import { Link } from '@common/components/Link';
import { HyperlinkFieldProps, useHyperlinkFieldController } from './hyperlink-field.controller';
import { DatasheetItemLabel } from '@modules/datasheets/components/datasheet-item-label';
import { DatasheetItem } from '@modules/datasheets/components/datasheet-item';
import { DatasheetFieldComponentHeadingPosition } from '@common/dto/datasheet/field-component/heading-position';
import { Flex } from '@common/components/Flex';
import { FieldContainer } from '../field-container';

import './hyperlink-field.styles.scss';

export const HyperlinkField: React.FC<HyperlinkFieldProps> = (props) => {
  const { datasheetElement } = props;

  const {
    handleInputMouseEnter,
    closeLink,
    inputRef,
    fieldCurrentValue,
    handleFieldValueChange,
    handleFieldBlur,
    handleFieldClick,
    isLinkOpen,
    linkCoordinates,
    fieldSavedValue,
    linkProps,
    emailValid,
    headingPlacedHorizontally, 
    headingReference, 
    headingSize, 
    headingPosition
  } = useHyperlinkFieldController(props);

  const labelComponent = (
    <DatasheetItemLabel
      reference={headingReference}
      inline={headingPlacedHorizontally}
      withImg={datasheetElement.original.showfieldtype}
      withText={datasheetElement.original.headdisplay}
      text={datasheetElement.original.headtext}
      img={datasheetElement.original.field.imageURL}
      textCustomization={{
        fontSize: datasheetElement.original.headfontsize,
        fontFamily: datasheetElement.original.headfont,
        color: datasheetElement.original.headcolor,
        align: datasheetElement.original.headalign,
        fontStyles: datasheetElement.original.headstyle,
      }}
    />
  );

  return (
    <DatasheetItem
      style={{
        top:
          datasheetElement.coordinates.y -
          (datasheetElement.original.headpos === DatasheetFieldComponentHeadingPosition.top ? headingSize.height : 0),
        left:
          datasheetElement.coordinates.x -
          (datasheetElement.original.headpos === DatasheetFieldComponentHeadingPosition.left ? headingSize.width : 0),
        display: headingPlacedHorizontally ? "flex" : "block",
        alignItems: headingPlacedHorizontally ? "flex-start" : undefined,
      }}
    >
      {[DatasheetFieldComponentHeadingPosition.top, DatasheetFieldComponentHeadingPosition.left].includes(
        headingPosition
      ) && labelComponent}
      <Flex alignItems="center">
        <FieldContainer 
          showBorder={datasheetElement.original.showborder}
          width={datasheetElement.original.width}
          height={datasheetElement.original.height}
        >
          <div
          className="DatasheetsResultHyperlinkField"
          onMouseEnter={handleInputMouseEnter}
          onMouseLeave={closeLink}
        >
          <FormControl
            inputRef={inputRef}
            title={fieldCurrentValue}
            className="DatasheetsResultHyperlinkField__input"
            type="text"
            value={fieldCurrentValue}
            onChange={handleFieldValueChange}
            onBlur={handleFieldBlur}
            onClick={handleFieldClick}
          />
          {isLinkOpen && fieldSavedValue && (
            <div 
              style={linkCoordinates} 
              className="DatasheetsResultHyperlinkField__actions" 
              onClick={closeLink}
            >
              <Link 
                title={fieldSavedValue}
                {...linkProps}
                className="DatasheetsResultHyperlinkField__actions__item"
                onClick={closeLink}
              >
                {emailValid ? fieldSavedValue : trDts('Open')}
              </Link>
            </div>
          )}
        </div>
        </FieldContainer>
      </Flex>
      {[DatasheetFieldComponentHeadingPosition.bottom, DatasheetFieldComponentHeadingPosition.right].includes(
        headingPosition
      ) && labelComponent}
    </DatasheetItem>
  );
};
